module.exports = __webpack_public_path__ + "img/1.181e1674.png";